module.exports = __webpack_public_path__ + "static/img/13bg_5.96590cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/13bg_5.png
// module id = 650
// module chunks = 1